// extracted by mini-css-extract-plugin
module.exports = {"labelRequire":"label-require_labelRequire__1pa9-","text":"label-require_text__2PsIB","require":"label-require_require__1efpu","warningChar":"label-require_warningChar__1XljO"};